import { useRouter, type NextRouter } from "next/router";

const FULL_PAGE_CONVERSATION_PATH = "/agent-conversations/[conversationId]";

/**
 * The conversation whose full-page view (or its artifacts page) the current route shows, or null.
 * While that page is up, the conversation's chat window stays hidden: the page is the
 * conversation, and the window comes back once the route leaves it.
 */
export const useFullPageConversationId = (): string | null => {
  // Outside a Next router (component tests) the hook returns null rather than a router.
  const router = useRouter() as NextRouter | null;
  if (router == null || !router.pathname.includes(FULL_PAGE_CONVERSATION_PATH)) return null;
  const { conversationId } = router.query;
  return typeof conversationId === "string" ? conversationId : null;
};
